// extracted by mini-css-extract-plugin
module.exports = {"attachments":"MessageFormAttachments_attachments__3Iy5i","close":"MessageFormAttachments_close__2lgg_"};